import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDTypography from "components/MDTypography"

// Report-page-only header: title + supporting copy on the left, primary
// action(s) on the right. Deliberately not the shared SectionCard/heading
// pattern — this page gets its own compact header treatment.
const ReportHeader = ({ title, subtitle, onExport, exportDisabled }) => (
  <MDBox
    display="flex"
    justifyContent="space-between"
    alignItems={{ xs: "flex-start", sm: "center" }}
    flexWrap="wrap"
    gap={2}
    mb={3}
  >
    <MDBox>
      <MDTypography variant="h4" fontWeight="bold">
        {title}
      </MDTypography>
      <MDTypography variant="body2" color="text" sx={{ mt: 0.5 }}>
        {subtitle}
      </MDTypography>
    </MDBox>
    <MDButton
      variant="outlined"
      color="secondary"
      size="small"
      disabled={exportDisabled}
      onClick={onExport}
      startIcon={<Icon fontSize="small">file_download</Icon>}
    >
      Export CSV
    </MDButton>
  </MDBox>
)

export default ReportHeader
